import { Col, Row, Button, Modal } from "react-bootstrap";

const PSO = ({ listingAgentDetails, psoDetails, propertyinfo, cms, state }) => {


  return (

    <div className="left_side_widget mb30 tour-pdp-details p0">
      <Row className="propertyInfoBoxHeading p0">
        <h3 className='propertyInfoBoxHeadingText' >
          Private Selling Officer (PSO)

        </h3>

      </Row>


<div className="p20">
   {
            <div className="row ">
              <p className="pdpHeadingMedium mobile-fs-pso wa" style={{width:'50%'}}>
                 PSO Name:{" "}
              </p>
              <p className="pdpText mobile-fs-pso wa">
                {(psoDetails?.name &&
                  psoDetails?.name != "-") ||
                  (psoDetails?.name && psoDetails?.name != "-")
                  ? `${psoDetails?.name}`
                  : ""}
              </p>
            </div>
          }

           {
            <div className="row ">
              <p className="pdpHeadingMedium mobile-fs-pso wa" st mobile-fsyle={{width:'50%'}}>
                Auctioneer License Number:{" "}
              </p>
              <p className="pdpText mobile-fs-pso wa">
                {(psoDetails?.auctioneerLicenseNumber &&
                  psoDetails?.auctioneerLicenseNumber != "-") ||
                  (psoDetails?.auctioneerLicenseNumber && psoDetails?.auctioneerLicenseNumber != "-")
                  ? `${psoDetails?.auctioneerLicenseNumber} `
                  : ""}
              </p>
            </div>
          }
           {
            <div className="row ">
              <p className="pdpHeadingMedium mobile-fs-pso wa" st mobile-fsyle={{width:'50%'}}>
                Real Estate License:{" "}
              </p>
              <p className="pdpText mobile-fs-pso wa">
                {(psoDetails?.realEstateBrokerNumber &&
                  psoDetails?.realEstateBrokerNumber != "-") ||
                  (psoDetails?.realEstateBrokerNumber && psoDetails?.realEstateBrokerNumber != "-")
                  ? `${psoDetails?.realEstateBrokerNumber} `
                  : ""}
              </p>
            </div>
          }
           {
            <div className="row ">
              <p className="pdpHeadingMedium mobile-fs-pso wa" st mobile-fsyle={{width:'50%'}}>
                Company Name:{" "}
              </p>
              <p className="pdpText mobile-fs-pso wa">
                {(listingAgentDetails?.agency &&
                  listingAgentDetails?.agency != "-") ||
                  (listingAgentDetails?.agency && listingAgentDetails?.agency != "-")
                  ? `${listingAgentDetails?.agency} `
                  : "Contact Agent for details"}
              </p>
            </div>
          }
           {
            <div className="row ">
              <p className="pdpHeadingMedium mobile-fs-pso wa" st mobile-fsyle={{width:'50%'}}>
                Phone Number :{" "}
              </p>
              <p className="pdpText mobile-fs-pso wa">
                {(listingAgentDetails?.listingAgentPhone &&
                  listingAgentDetails?.listingAgentPhone != "-") ||
                  (listingAgentDetails?.listingAgentPhone && listingAgentDetails?.listingAgentPhone != "-")
                  ? `${listingAgentDetails?.listingAgentPhone} `
                  : "Contact Agent for details"}
              </p>
            </div>
          }
           {
            <div className="row ">
              <p className="pdpHeadingMedium mobile-fs-pso wa" st mobile-fsyle={{width:'13%'}}>
                Email: {" "}
              </p>
              <p className="pdpText  mobile-fs-pso wa">
                {(listingAgentDetails?.listingAgentEmailId &&
                  listingAgentDetails?.listingAgentEmailId != "-") ||
                  (listingAgentDetails?.listingAgentEmailId && listingAgentDetails?.listingAgentEmailId != "-")
                  ? `${listingAgentDetails?.listingAgentEmailId} `
                  : ""}
              </p>
            </div>
            
          }

 </div>

    </div>
   
  );
};

export default PSO;
